import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgMessaging = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 15"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            stroke="#fff"
            strokeWidth={1.125}
            d="M1.25 3.625A2.813 2.813 0 0 1 4.063.813h7.875a2.813 2.813 0 0 1 2.812 2.812V9.25a2.813 2.813 0 0 1-2.812 2.813H5.32c-.174 0-.347.04-.503.118L1.25 13.965z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgMessaging)
const Memo = memo(ForwardRef)
export default Memo
